/**
 * Context for the StationStatus snapshot. Allows `StationCardOrDetailsRouter`
 * and other consumers to read the current live status map without prop-drilling
 * through AppShell → StationDetailHost → router.
 *
 * The preloader is owned by `<StationStatusController>` (mounted at app root).
 * The context value is updated on every `cache.updates()` emission.
 */
import { createContext, useContext } from 'react'
import type { StationStatusSnapshot } from '@metro/station-status'

/** An empty snapshot represents the Open state for all stations. */
export const StationStatusContext = createContext<StationStatusSnapshot>({})

/**
 * Read the current live status snapshot. Absent key = Open (no banner).
 * Returns an empty record until the first cache update arrives.
 */
export function useStationStatuses(): StationStatusSnapshot {
  return useContext(StationStatusContext)
}
